interface StatusIndicatorProps {
  type: 'xml' | 'lua';
  loading: boolean;
  loaded: boolean;
  filename?: string;
  error?: string;
}

export function StatusIndicator({ type, loading, loaded, filename, error }: StatusIndicatorProps) {
  const getStatusClass = () => {
    if (loading) return 'status-indicator loading';
    if (error) return 'status-indicator error';
    if (loaded) return 'status-indicator success';
    return 'status-indicator';
  };

  const getStatusText = () => {
    if (loading) {
      return `Loading ${type.toUpperCase()} file...`;
    }
    if (error) {
      return `Failed to load ${type.toUpperCase()} file`;
    }
    if (loaded && filename) {
      const label = type === 'xml' ? 'XML loaded' : 'Vehicles loaded';
      return `${label}: ${filename}`;
    }
    const label = type === 'xml' ? <><span>No XML file loaded</span><br /><span className="vehicles-lua-filename">Required</span></> : <><span>No Lua file loaded</span><br /><span className="vehicles-lua-filename">optional (recommended)</span></>; 
    return label;
  };

  return (
    <div className="file-status">
      <div className="status-line">
        <span className={getStatusClass()}>● {'\u00A0'}</span>
        <span className="status-text">{getStatusText()}</span>
      </div>
    </div>
  );
}